export default __webpack_public_path__ + "static/media/airab.b9bd0f8e.PNG";